import { useSelector } from "react-redux"
import { GetPrimaryColorHex } from "redux/slices/brand"

export default function LabelledIconButton({
    icon,
    style = 'white',
    disabled = false,
    action = () => { console.log('Add a button action') },
}) {

    const styleConfig = useSelector((state) => state.brand.styleConfig)

    return (
        <div>
            <button 
                className={`
                    w-full h-20 flex flex-col items-center justify-center rounded-xl font-normal
                    ${style === 'white' && 'bg-white border border-gray-400'}
                `}
                style={{ 
                    backgroundColor: style === 'brand-color' ? GetPrimaryColorHex(styleConfig) : '',
                    WebkitTapHighlightColor: 'transparent',
                    WebkitTouchCallout: 'none',
                    WebkitUserSelect: 'none',
                    userSelect: 'none',
                    outline: 'none'
                }}
                disabled={disabled}
                onClick={action} 
                onFocus={(e) => e.target.style.outline = 'none'}
                onBlur={(e) => e.target.style.outline = 'none'}
            >
                {icon}
            </button>
        </div>
    )
}